export const langList :any = [
    {
        id:(Math.random()*100).toString(36),
        code:"en",
        title:"English",
    },
    {
        id:(Math.random()*100).toString(36),
        code:"ar",
        title:"العربية"
    }
]